import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  scroll-behavior: smooth;
  margin-top: 75px;
}

body {
  margin: 0;
  font-family: 'Roboto Condensed', sans-serif;
  overflow-x: hidden;
  max-width: 1800px;
  margin: 0 auto;
}

.flybook {
  background-color: #F75A0E;
  width: 110px;
  height: 40px;
  font-size: 14px;
  font-family: 'Roboto Condensed', sans-serif;
  font-weight: 700;
  padding: .75em;
  border-radius: 20px;
}

.navbar {
  position: fixed;
  top: 0;
  left: 0;
  box-shadow: 0 3px 8px -6px gray;
}

.navLink:visited {
  color: '#F75A0E';
}

.navLink:link {
  color: '#F75A0E';
}

.navLink {
  text-decoration: none;
  color: '#F75A0E';
}

.footerLink:visited {
  color: '#FFFFFF';
}

.footerLink:link {
  color: '#FFFFFF';
}

.footerLink {
  text-decoration: none;
  color: '#FFFFFF';
}

.clickableArea {
  display: inline-block;
  position: relative;
  z-index: 1;
  padding-right: 400px;
  padding-left: 400px;
  padding-top: 40px;
  padding-bottom: 40px;

  margin-right: -400px;
  margin-left: -400px;
  margin-top: -40px;
  margin-bottom: -40px;
}

video {
  object-fit: cover;
}

.heroImage {
    position: relative;
    width: 100vw;
    height: 85vh;
    object-fit: cover;
    filter: brightness(70%);
}

.link {
  color: #ffffff;
  text-decoration: none;
}

.heroLink {
  display: block;
  width: 200px;
  color: #ffffff;
  text-decoration: none;
}

.heroVideoOverlay {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  justify-content: center;
  align-items: center;
}

.headline {
  color: #888667;
  font-family: 'Roboto Condensed', sans-serif;
  font-weight: 700;
}

.headline-black {
  color: #181617;
  font-family: 'Roboto Condensed', sans-serif;
  font-weight: 700;
}

.headline-centered {
  color: #888667;
  font-family: 'Roboto Condensed', sans-serif;
  font-weight: 700;
  text-align: center;
}

.subheading {
  color: #181617;
  font-family: 'Lora', serif;
}

.subheading-centered {
  color: #181617;
  font-family: 'Lora', serif;
  text-align: center;
}

.hr-centered {
  margin: 0 auto;
  margin-top: 1em;
  margin-bottom: 1em;
}

.paragraph {
  color: #181617;
  font-family: 'Lora', serif;
  font-size: 18px;
  line-height: 1.5;
}

.paragraph-centered {
  color: #181617;
  font-family: 'Lora', serif;
  text-align: center;
  max-width: 500px;
  margin: 0 auto;
  line-height: 1.5;
}

.paragraph-two {
  margin-top: 1em;
  color: #181617;
  font-family: 'Lora', serif;
  line-height: 1.5;
}

.container {
  margin: 2em;

  @media only screen and (min-width: 650px) {
    margin: 4em;
  }
}

.centered-in-grid {
  grid-column: 1/3;
}

.card-logo {
  width: 50px;
  color: white;
}

.card-logo-booking {
  width: 50px;
  color: white;
}

.card-logo-container {
  align-self: center;
}

.detail-content-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-column: 1/2;
}

.detail-paragraph {
  margin: 1em 0 0 0;
}

.detail-heading {
  margin: 1.5em 0 0 0;
  color: #888667;
}

.detail-list > ul {
  margin: 1em 0 0 2em;
  list-style: none;
  position: relative;
}

.detail-list > ul > li {
  padding-top: .25em;
}

.detail-list > ul > li::before {
  content: "•";
  color: #F75A0E;
  position: absolute;
  left: -0.8em;
  font-size: 1.1em;
}

.nextui-c-hPzDAx .nextui-collapse-title {
  color: #888667;
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 1.4em;
}

.nextui-c-fUXRSc path {
  stroke: #F75A0E;
}

.collapse-text {
  color: #181617;
  font-family: 'Lora', serif;
  font-size: 18px;
}

@media only screen and (min-width: 800px) {
  .detail-content-container {
    grid-column: 1/4;
  }
}

.nextui-c-dfbgCO-idIWWzx-css {
  align-items: center;
}

.imageSlider {
  display: none;

  @media only screen and (min-width: 1200px) {
    display: block;
  }
}

.horizontal-small {
  margin-top: .5em;
  margin-bottom: .5em;
}

.destinations-link {
  font-size: 20px;
  color: #F75A0E;
  background: linear-gradient(#506A63 0 0) var(--p,0)/var(--p,0) no-repeat;
  transition: .4s,background-position 0s;
  cursor: pointer;
  margin-top: .5em;
}

.destinations-link:hover {
  --p: 100%;
  color: #FFFFFF;
  cursor: pointer;
}

.destinations-detail-text {
  padding: 0 1em 1em 1em;

  @media only screen and (min-width: 1000px) {
    padding: 0;
  }
}

.left-hero-image {
  width: 100%;
  grid-column: 1/2;
  padding: 1em;

  @media only screen and (min-width: 1000px) {
    grid-row: 1/2;
    padding: 4em;
  }
}

.bottom-left-image {
  width: 100%;
  grid-column: 1/2;
  padding: 1em;

  @media only screen and (min-width: 1000px) {
    grid-row: 1/2;
    padding: 0;
  }
}

.bottom-middle-image {
  width: 100%;
  grid-column: 1/2;
  padding: 1em;

  @media only screen and (min-width: 1000px) {
    grid-column: 2/3;
    padding: 0;
  }
}

.bottom-right-image {
  width: 100%;
  grid-column: 1/2;
  padding: 1em;

  @media only screen and (min-width: 1000px) {
    grid-column: 3/4;
    padding: 0;
  }
}

.destinations-middle-section {
  max-width: 800px;
  text-align: center;
}

.carousel {
  text-align: center;
  max-width: 850px;
  max-height: 500px;

  @media only screen and (min-width: 1000px) {
    grid-column: 3/4;
    margin: 4em auto;
  }
}

.history-middle-section {
  max-width: 900px;
  text-align: left;
}

/*History Images*/

.history-hundred-years {
  width: 200px;
  grid-column: 1/2;
  padding: 1em;

  @media only screen and (min-width: 1000px) {
    grid-row: 1/2;
    padding: 1em;
  }
}

.history-marilyn {
  width: 200px;
  grid-column: 1/2;
  padding: 1em;

  @media only screen and (min-width: 1000px) {
    grid-row: 3/4;
    padding: 1em;
  }
}

.custom-wrapper-class {
  display: grid;
  grid-template-columns: 1fr;
  padding: 2em;
  gap: 2em;

  @media only screen and (min-width: 1000px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
}

`;

export default GlobalStyles;
